module.exports = __webpack_public_path__ + "img/spec-es.da043cb9.jpg";